// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-day-template-js": () => import("./../../src/components/DayTemplate.js" /* webpackChunkName: "component---src-components-day-template-js" */),
  "component---src-components-page-template-js": () => import("./../../src/components/PageTemplate.js" /* webpackChunkName: "component---src-components-page-template-js" */),
  "component---src-pages-404-js": () => import("./../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

